import { useEffect, useState } from 'react';

export const useIsMounted = (): boolean => {
  const [isMounted, setMountedState] = useState<boolean>(false);

  useEffect(() => {
    setMountedState(true);
  }, []);

  return isMounted;
};
